module.exports = __webpack_public_path__ + "static/EYE_green_wide-0a72f74a959f54d0f3e4bb8c67f6f158.jpg";